module.exports = __webpack_public_path__ + "static/media/fuel-sm.73ad173b.svg";